
//jQuery(document).ready(function() {
if(jQuery('.page-template-template-accueil').length) {
	var test = 1;


	// CHANGEMENTS DE COULEUR
	
	// Changement couleur textes en-tête
	gsap.to('section#entete .overlay h1, section#entete .overlay h2, section#entete .overlay p', { 
		color: '#fff',
		filter: 'blur(3px)',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
		}
	});
	gsap.to('section#entete .bouton.floating', { 
		color: '#fff',
		backgroundColor: '#000',
		border: '1px solid #fff',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
		}
	});
	gsap.to('section#entete .bouton.yellow', { 
		color: '#fff',
		backgroundColor: '#000',
		border: '1px solid #fff',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
		}
	});

	// Changement couleur backgrounds
	gsap.to('.zone_dessin, .rond_bg_blob', { 
		backgroundColor: '#000000',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
		}
	});
	// gsap.to('section#entete', { 
	// 	backgroundColor: '#000000',
	// 	scrollTrigger: {
	// 		trigger: 'section#entete',
	// 		start: 'bottom+=350 bottom',
	// 		end: 'bottom+=550 bottom',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 	}
	// });
	// gsap.to('section#beaute', { 
	// 	backgroundColor: '#000000',
	// 	scrollTrigger: {
	// 		trigger: 'section#entete',
	// 		start: 'bottom+=350 bottom',
	// 		end: 'bottom+=550 bottom',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 	}
	// });
	// gsap.to('.jonction_fix', { 
	// 	backgroundColor: '#000000',
	// 	scrollTrigger: {
	// 		trigger: 'section#entete',
	// 		start: 'bottom+=350 bottom',
	// 		end: 'bottom+=550 bottom',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 	}
	// });

	// Changement couleur textes beaute
	gsap.to('section#beaute', { 
		color: '#fff',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
		}
	});

	
	// DÉPLACEMENT DESSIN
	gsap.to('.zone_dessin .svg_container', { 
		top: 'calc(100% - 80px)',
		ease: Power0.easeNone,
		scrollTrigger: {
			trigger: '.zone_dessin',
			start: 'top top',
			end: 'bottom top',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});


	// DISPARITION GROSSE BOULE EN-TETE
	gsap.fromTo('section#entete #blob .canvas_container', {filter: 'blur(0px)'}, { 
		filter: 'blur(10px)',
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

		
	// ANIMATION LIGNES VISAGE
	var tl_lines = gsap.timeline({repeat:0, yoyo:false});

	// Apparition progressive
	// gsap.to('#svg_visage path', { 
	// 	strokeOpacity: '1',
	// 	ease: Power1.easeIn,
	// 	scrollTrigger: {
	// 		trigger: 'section#beaute',
	// 		start: 'top+=250 bottom',
	// 		end: 'bottom-=100 bottom',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 		//markers: true
	// 	}
	// });
	
	// Changement couleur
	gsap.to('#svg_visage path', { 
		stroke: '#777',
		ease: Power1.easeIn,
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=550 bottom',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});
	gsap.to('#svg_visage_fond path', { 
		stroke: '#333',
		ease: Power1.easeIn,
		scrollTrigger: {
			trigger: 'section#entete',
			start: 'bottom+=350 bottom',
			end: 'bottom+=500 bottom',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	// Définition animations traits
	tl_lines.fromTo('#svg_visage .line-haut', {drawSVG:"100% 100%"}, { 
		drawSVG:"100% 0%",
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'top bottom',
			end: 'bottom-=100 center',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	tl_lines.fromTo('#svg_visage .line-principale', {drawSVG:"0% 0%"}, { 
		drawSVG:"0% 100%",
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'top+=250 bottom',
			end: 'bottom+=500 bottom',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	tl_lines.fromTo('#svg_visage .line-oeil-gauche', {drawSVG:"0% 0%"}, { 
		drawSVG:"0% 100%",
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'center bottom',
			end: 'center+=400 center',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	tl_lines.fromTo('#svg_visage .line-oeil-droit', {drawSVG:"0% 0%"}, { 
		drawSVG:"0% 100%",
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'center bottom',
			end: 'center+=400 center',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	tl_lines.fromTo('#svg_visage .line-bas', {drawSVG:"0% 0%"}, { 
		drawSVG:"0% 100%",
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'center-=150 center',
			end: 'center top',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});


	// ANIMATION BOULE LE LONG DU TRAIT
	gsap.to(".zone_dessin .golden_ball", {
		motionPath:{
			path: ".path-anim-rond",
			align: ".path-anim-rond",
			autoRotate: true,
			alignOrigin: [0.5, 0.85]
		},
		scrollTrigger: {
			trigger: 'section#beaute',
			start: 'top-=150 top',
			end: 'bottom+=500 center+=150',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});


	// DISPARITION TEXTES FLOUS
	//var divs_flou = ['.titre_beaute', '.texte_gauche', '.texte_milieu'];
	var divs_flou = ['.textes_gauche .paragraphe_intro', '.textes_gauche .texte', '.liste_poles'];
	divs_flou.forEach(div => {
		gsap.to('section#beaute '+div, { 
			filter: 'blur(3px)',
			scrollTrigger: {
				trigger: 'section#beaute '+div,
				start: 'bottom-=300 top',
				end: 'bottom top',
				scrub: true,
				invalidateOnRefresh: true,
				//markers: true
			}
		});
	});
	// gsap.to('section#beaute .texte_droite', { 
	// 	filter: 'blur(3px)',
	// 	scrollTrigger: {
	// 		trigger: 'section#beaute .texte_droite',
	// 		start: 'top-=100 top',
	// 		end: 'top+=100 top',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 		//markers: true
	// 	}
	// });

	gsap.to('section#beaute .titre_beaute', { 
		filter: 'blur(3px)',
		scrollTrigger: {
			trigger: 'section#beaute .titre_beaute',
			start: 'top-=150 top',
			end: 'top top',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	// gsap.to('section#beaute .texte_gauche', { 
	// 	filter: 'blur(3px)',
	// 	scrollTrigger: {
	// 		trigger: 'section#beaute .texte_gauche',
	// 		start: 'top-=250 top',
	// 		end: 'top-=50 top',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 		markers: true
	// 	}
	// });


	// PREMIERE ARRIVÉE RONDS SUIVEURS
	// Animation arrivée/départ rond control slider
	// gsap.fromTo('section#slider .rond_control', {top: '-500px', left: '62%'}, {
	// 	top: '200px',
	// 	left: '62%',
	// 	scrollTrigger: {
	// 		trigger: 'section#slider',
	// 		start: 'top+=30 bottom',
	// 		end: 'top+=300 bottom',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 		//markers: true
	// 	}
	// });
	gsap.fromTo('section#expertise .rond_control', {top: '-450px', left: '62%'}, {
		top: '250px',
		left: '62%',
		scrollTrigger: {
			trigger: 'section#expertise',
			start: 'top+=50 bottom',
			end: 'top+=350 bottom',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	// LIGNE BAS EQUIPE
	gsap.fromTo('svg#svg_equipe path', {drawSVG:"0% 0%"}, { 
		drawSVG:"0% 100%",
		scrollTrigger: {
			trigger: 'svg#svg_equipe',
			start: 'center bottom',
			end: 'center top',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

	// GESTION DECLENCHEMENT ANIMATION BOULE FIL

	// Get "expertise" section start and end in vars
	var expertise_top = jQuery('section#expertise').position().top;
	var expertise_bottom = expertise_top + jQuery('#expertise').height();
	
	var soins_top = jQuery('section#solutions').position().top;
	var soins_bottom = soins_top + jQuery('#solutions').height();
	
	// var slider_top = jQuery('section#slider').position().top;
	// var slider_bottom = slider_top + jQuery('#slider').height();

	// When cursor move, check if "boule fil" animation should be played or reversed 
	var boule_fil_state = false;
	document.addEventListener('cursormove', (e) => {
		// If mouse lower than bottom of expertise section
		if(yPos > expertise_bottom) {
			// If animation state is at start
			if(!boule_fil_state) {
				var container_startX = jQuery('section#soins .entete').position().left;
				var container_width = jQuery('section#soins .entete').width();
				var pos_souris = xPos - container_startX;
				var percents = (pos_souris / container_width) * 100;
				percents = Math.min(Math.max(percents, 0), 100);
				
				// Play animation forward
				jQuery('section#soins .anim_container').css('left', percents+'%');
				gsap.to(tl_boule, { duration: 1, progress: 1, overwrite: "auto", ease: "Bounce.easeOut" });
				gsap.to(tl_trait_bounce, { duration: 1, progress: 1, overwrite: "auto", ease: "Bounce.easeOut" });
				boule_fil_state = true;
			}
		}
		// If mouse higher than bottom of expertise section
		if(yPos < expertise_bottom) {
			// If animation state is at end
			if(boule_fil_state) {
				// Play animation backwards
				gsap.to(tl_boule, { duration: 1, progress: 0, overwrite: "auto", ease: "power4.out" });
				gsap.to(tl_trait_bounce, { duration: 1, progress: 0, overwrite: "auto", ease: "power4.out" });
				boule_fil_state = false;
			}
		}
	}, false);

	var boule_fil_state_tech = false;
	document.addEventListener('windowScroll', (e) => {

		//var solutions_top = jQuery('section#solutions').offset().top;
		//var solutions_bottom = solutions_top + jQuery('section#solutions').outerHeight();
		var trigger_level = smoother.offset("section#solutions", "bottom bottom") + 250;
		//console.log('trigger_level : '+trigger_level+', current_scroll : '+current_scroll+', current window bottom : '+(current_scroll + window.innerHeight));

		// If scroll level is right
		if(current_scroll > trigger_level) {
			// If animation state is at start
			if(!boule_fil_state_tech) {
				
				// Play animation forward
				gsap.to(tl_boule_tech, { duration: 1, progress: 1, overwrite: "auto", ease: "Bounce.easeOut" });
				gsap.to(tl_tech_trait_bounce, { duration: 1, progress: 1, overwrite: "auto", ease: "Bounce.easeOut" });
				boule_fil_state_tech = true;
			}
		}
		// If mouse higher than bottom of expertise section
		if(current_scroll < trigger_level) {
			// If animation state is at end
			if(boule_fil_state_tech) {
				// Play animation backwards
				gsap.to(tl_boule_tech, { duration: 1, progress: 0, overwrite: "auto", ease: "power4.out" });
				gsap.to(tl_tech_trait_bounce, { duration: 1, progress: 0, overwrite: "auto", ease: "power4.out" });
				boule_fil_state_tech = false;
			}
		}
	}, false);

	// On resize, update sections start and end
	document.addEventListener('windowresize', (e) => {
		
		expertise_top = jQuery('section#expertise').position().top;
		expertise_bottom = expertise_top + jQuery('#expertise').height();

		soins_top = jQuery('section#solutions').position().top;
		soins_bottom = soins_top + jQuery('#solutions').height();

		// slider_top = jQuery('section#slider').position().top;
		// slider_bottom = slider_top + jQuery('#slider').height();		

	}, false);
	

	// ANIMATION BOULE FIL
	
	// Boule soins
	var tl_boule = gsap.timeline({ paused: true, defaults: {
		ease: 'none'
	  } })
	.fromTo('section#soins .boule', {bottom: '300px'}, {
		duration: 1,
		bottom: '8px',
		//ease: Bounce.easeOut,
	});

	// Trait soins
	var tl_trait = gsap.timeline({ paused: true })
	.to('section#soins svg.title_line .straight', {
		duration: 0.9,
		morphSVG: "section#soins svg.title_line .straight",
	})
	.to('section#soins svg.title_line .straight', {
		duration: 0.1,
		morphSVG: "section#soins svg.title_line .curved",
	});

	var tl_trait_bounce = gsap.timeline({ paused: true, defaults: {
		ease: 'none'
	  } })
	.to(tl_trait, {
		time:tl_trait.duration(), 
		duration:tl_trait.duration(), 
		//ease: Bounce.easeOut,
	});


	// Boule tech
	var tl_boule_tech = gsap.timeline({ paused: true, defaults: {
		ease: 'none'
	  } })
	.fromTo('section#technologies .boule', {bottom: '300px'}, {
		duration: 1,
		bottom: '8px',
		//ease: Bounce.easeOut,
	});

	// Trait tech
	var tl_tech_trait = gsap.timeline({ paused: true })
	.to('section#technologies svg.title_line .straight', {
		duration: 0.9,
		morphSVG: "section#technologies svg.title_line .straight",
	})
	.to('section#technologies svg.title_line .straight', {
		duration: 0.1,
		morphSVG: "section#technologies svg.title_line .curved",
	});

	var tl_tech_trait_bounce = gsap.timeline({ paused: true, defaults: {
		ease: 'none'
	  } })
	.to(tl_tech_trait, {
		time:tl_tech_trait.duration(), 
		duration:tl_tech_trait.duration(), 
		//ease: Bounce.easeOut,
	});


	// LIGNE RDV
	// gsap.fromTo('svg#visage_rdv path', {drawSVG:"0% 0%"}, { 
	// 	drawSVG:"0% 100%",
	// 	scrollTrigger: {
	// 		trigger: 'section#rdv',
	// 		start: 'top+=400 bottom',
	// 		end: 'bottom+=200 top',
	// 		scrub: true,
	// 		invalidateOnRefresh: true,
	// 	}
	// });

	// DISPARITION RDV
	gsap.to('section#rdv .link', { 
		filter: 'blur(4px)',
		scrollTrigger: {
			trigger: 'section#rdv .link',
			start: 'bottom-=300 top',
			end: 'bottom top',
			scrub: true,
			invalidateOnRefresh: true,
			//markers: true
		}
	});

}
//});